import './App.css';
import Header from './Components/Views/Header'
import Main from './Components/Logic/Main'

function App() {
  
  return (
    <div className="App">
      <Header/>
      <Main/>
    </div>
  );
}

export default App;
